exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-client-filter-content[data-v-06fd288e] {\n  min-width: 280px;\n}\n.kv-client-filter-content[data-v-06fd288e] .kv-search-input-wrapper {\n  margin-bottom: 0;\n}\n.kv-client-filter-content[data-v-06fd288e] .kv-search-input {\n  padding: 8px 36px 8px 12px;\n  font-size: 13px;\n  height: 36px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fff;\n}\n.kv-client-filter-content[data-v-06fd288e] .kv-search-results {\n  position: relative;\n  margin-top: 8px;\n  max-height: 240px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: none;\n}\n", ""]);

// exports
